import React, { useReducer, createContext, useState } from "react";

export const contexData = createContext({}); //创建共享数据

export const reducer = (state, action) => {
  //创建reducer条件
  switch (action.type) {
    case "init":
      return { ...state, ...action.data };
    case "highlight":
      return { ...state, ...action.data };
    case "crouselRef":
      return {...state, ...action.data};
    default:
      return state;
  }
};

export const ContextComponent = (props) => {
  const [infoContex, dispatch] = useReducer(reducer, {});
  const [isBack, setIsBack] = useState(false);
  return (
    <contexData.Provider value={{ infoContex, dispatch, isBack, setIsBack }}>
      {props.children}
    </contexData.Provider>
  );
};
